import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from '@emotion/styled'
import * as styleConfig from '../../styles/config.module.scss';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import { useLocalization } from 'gatsby-theme-i18n';

const Copyright = () => {

  const { t } = useLocalization();

  const data = useStaticQuery(graphql`
  query Copyright {
    se_logo : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/logo_squareEnix.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
  }
`)

  return(
    <CopyrightWrapper>
      <a href={t('common.footer.sqex.logo.url')} target="_blank" rel="canonical noreferrer noopener">
        <SELogo image={getImage(data.se_logo)} alt={t('common.footer.sqex.logo.title')}/>
      </a>
      <CopyrightText>
        {t('common.footer.copyright')}<br/>{t('common.footer.copyright.option')}
      </CopyrightText>
    </CopyrightWrapper>
  )
}

export default Copyright;

const CopyrightWrapper = styled.div`
  display:flex;
  background:#212324;
  justify-content:space-between;
  align-items:center;

  height:96px;
  line-height:96px;
  padding:0 ${styleConfig.glitterHorizontalXL};

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:auto;
    line-height:auto;
    display:block;
    padding:48px 24px;
    text-align;center;
  }
`
const SELogo = styled(GatsbyImage)`
  width:229px;
  height:32px;
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 auto 24px;
  }
`

const CopyrightText = styled.div`
  font-size:14px;
  line-height:16px;
  color:#C8C8CC;
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size:12px;
    text-align:center;
  }
`
